var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _vm.label || _vm.$slots.label
      ? _c(
          "label",
          {
            class: [_vm.prefixCls + "-label"],
            style: _vm.labelStyles,
            attrs: { for: _vm.labelFor }
          },
          [
            _vm._t("label", function() {
              return [
                _vm._v(_vm._s(_vm.label) + _vm._s(_vm.FormInstance.colon))
              ]
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { class: [_vm.prefixCls + "-content"], style: _vm.contentStyles },
      [
        _vm._t("default"),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.validateState === "error" &&
          _vm.showMessage &&
          _vm.FormInstance.showMessage
            ? _c("div", { class: [_vm.prefixCls + "-error-tip"] }, [
                _vm._v(_vm._s(_vm.validateMessage))
              ])
            : _vm._e()
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3731a28b", { render: render, staticRenderFns: staticRenderFns })
  }
}